import {action} from "mobx";
import courierAdjustmentService from "../services/courierAdjustmentService";
import appStore from "./appStore";

class courierAdjustmentStore {
    // Adjustment Types Actions
    @action getAdjustmentTypes = async params => {
        const resultOfRequest = await courierAdjustmentService.getAdjustmentTypes(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action createAdjustmentType = async params => {
        const resultOfRequest = await courierAdjustmentService.createAdjustmentType(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({content: "Eklenti/Kesinti tipi başarıyla oluşturuldu."});
        return resultOfRequest.data;
    };

    @action updateAdjustmentType = async (id, params) => {
        const resultOfRequest = await courierAdjustmentService.updateAdjustmentType(id, params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({content: "Eklenti/Kesinti tipi başarıyla güncellendi."});
        return resultOfRequest.data;
    };

    @action deleteAdjustmentType = async id => {
        const resultOfRequest = await courierAdjustmentService.deleteAdjustmentType(id);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({content: "Eklenti/Kesinti tipi başarıyla silindi."});
        return resultOfRequest.data;
    };

    // Courier Adjustments Actions
    @action getCourierAdjustments = async params => {
        const resultOfRequest = await courierAdjustmentService.getCourierAdjustments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierAdjustmentsTemplate = async () => {
        const resultOfRequest = await courierAdjustmentService.getCourierAdjustmentsTemplate();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return null;
        }
        return resultOfRequest.data;
    };

    @action uploadCourierAdjustments = async params => {
        const resultOfRequest = await courierAdjustmentService.uploadCourierAdjustments(params);
        const data = resultOfRequest?.data?.result || resultOfRequest?.data;
        if (resultOfRequest.status !== 200 && !data?.errorExcel) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return {
            data: resultOfRequest.data.result || resultOfRequest.data
        };
    };
}

export default new courierAdjustmentStore();
